<template>
  <button-dialog-container
    ref="dialogContainer"
    :title-dialog="titleDialog"
    :only-icon="onlyIcon"
    :btn-icon="icon"
    :btn-text="btnText"
    :is-valid-disabled="isValidDisabled"
    :is-button-disabled="getIsLoading"
    @ok-pushed="openProject"
  >
    <v-container>
      <v-row v-if="!loadType">
        <v-col>
          <v-text-field
            v-model="computedProjectName"
            :label="$t('project.name')"
            :error="projectNameError"
            :error-messages="errorMessage"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="!loadType"
        id="timeRow"
      >
        <v-col
          v-if="!timeMode"
          id="timeField"
          cols="11"
        >
          <v-text-field
            v-model="computedProjectDuration"
            :label="$t('project.duration-label-secs')"
            type="Number"
            max="86400"
            :error="projectDurationError"
            :error-messages="projectDurationErrorMessage"
          />
        </v-col>
        <v-col
          v-if="timeMode"
          cols="11"
        >
          <v-input
            :error="projectDurationError"
            :error-messages="projectDurationErrorMessage"
          >
            <template v-slot:label>
              <v-label id="label-duration">
                {{ $t("project.duration-label-format") }}
              </v-label>
            </template>
            <template v-slot:default>
              <vue-timepicker
                id="timepicker"
                v-model="computedDuration"
                format="HH:mm:ss"
                fixed-dropdown-button
                hide-clear-button
                manual-input
              />
            </template>
          </v-input>
        </v-col>
        <v-col cols="1">
          <v-btn
            icon
            @click="timeMode = !timeMode"
          >
            <v-icon>mdi-timer-refresh-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <file-explorer
            :dir="dirOpen"
            :filter="['.zip']"
            :selectable="false"
            :activatable="true"
            :open-on-click="false"
            @item-selected="itemSelected"
          />
        </v-col>
      </v-row>
      <v-row v-if="false">
        <v-col cols="11">
          <!-- Ajouter un selecteur de tag pour classer le template -->
          <v-switch
            v-model="isTemplate"
            dense
            flat
            class="mb-n5"
            :label="'Enregistrer comme template'"
          />
        </v-col>
      </v-row>
    </v-container>
  </button-dialog-container>
</template>

<script>
// External components
import vueTimepicker from "vue2-timepicker";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

// Components
import fileExplorer from "../Common/FileExplorer";
import buttonDialogContainer from "../Common/ButtonDialogContainer";

// Libs
const moment = require("moment");

// Tools
const pathInfo = require("path");

export default {
  components: {
    vueTimepicker,
    fileExplorer,
    buttonDialogContainer,
  },
  props: {
    baseProjectName: {
      type: String,
      default: "",
    },
    baseProjectDuration: {
      type: Number,
      default: 10,
    },
    btnText: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-content-save",
    },
    loadType: {
      type: Boolean,
      default: false,
    },
    onlyIcon: {
      type: Boolean,
      default: true,
    },
    titleDialog: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dirOpen: this.$store.state.config.dirs.root + "mediacenter/" + this.$store.state.user.socId,
      errorMessage: "",
      path: [this.$store.state.config.dirs.root + "mediacenter/" + this.$store.state.user.socId],
      projectDuration: 10,
      projectDurationError: false,
      projectDurationErrorMessage: "",
      projectName: "",
      projectNameError: false,
      selection: null,
      timeMode: true,
      isTemplate: false,
    };
  },
  computed: {
    computedProjectName: {
      get() {
        return this.projectName;
      },
      set(value) {
        if (this.isValidFilename(value)) {
          this.projectName = value;
          this.projectNameError = false;
          return;
        }
        this.projectNameError = true;
      },
    },
    computedProjectDuration: {
      get() {
        return this.projectDuration;
      },
      set(value) {
        this.projectDuration = value;
        if (this.projectDuration < 1) {
          this.projectDurationErrorMessage = this.$t("field.min-duration");
          this.projectDurationError = true;
          return;
        } else if (this.projectDuration > 86400) {
          this.projectDurationErrorMessage = this.$t("field.max-duration");
          this.projectDurationError = true;
          return;
        }

        this.projectDurationErrorMessage = "";
        this.projectDurationError = false;
      },
    },
    computedDuration: {
      get() {
        const formatted = moment.utc(this.projectDuration * 1000).format("HH:mm:ss");
        return formatted;
      },
      set(value) {
        const secs = moment(value, "HH:mm:ss").diff(moment().startOf("day"), "seconds");

        if (secs < 1) {
          this.projectDurationErrorMessage = this.$t("field.min-duration");
          this.projectDurationError = true;
          return;
        } else if (secs > 86400) {
          this.projectDurationErrorMessage = this.$t("field.max-duration");
          this.projectDurationError = true;
          return;
        }

        this.projectDurationErrorMessage = "";
        this.projectDurationError = false;

        this.projectDuration = secs;
      },
    },
    isValidDisabled() {
      return !this.projectName != "" || this.projectNameError || this.projectDurationError;
    },
    getIsLoading() {
      return this.$store.state.project.isLoading;
    },
    completePath() {
      return this.deleteInvalidBackslash(this.path + "/" + this.projectName + ".zip");
    },
  },
  watch: {
    isValidDisable: function (val) {
      if (this.loadType) {
        return this.projectName != "";
      }

      if (val) {
        // eslint-disable-next-line no-useless-escape
        this.errorMessage = "Can't use <>:\"/\|?* in a filename, filename cannot be empty";
        return;
      }

      this.errorMessage = "";
    },
    baseProjectName: function () {
      this.projectName = this.baseProjectName;
    },
    baseProjectDuration: function () {
      this.projectDuration = this.baseProjectDuration;
    },
  },
  mounted() {
    this.projectName = this.baseProjectName;
    this.projectDuration = this.baseProjectDuration;

    if (this.projectName == "" && !this.loadType) {
      this.projectName = this.$t("project.blank-title");
    }

    // If dir limited for user we use this root path
    if (this.$store.state.user.dir != "") {
      this.dirOpen = this.$store.state.user.dir;
    }
  },
  methods: {
    deleteInvalidBackslash(path) {
      return path.split("\\").join("/");
    },
    openProject() {
      this.$emit("select", {
        duration: this.projectDuration,
        projectName: this.projectName,
        savePath: this.completePath,
        isTemplate: this.isTemplate,
      });
    },
    isValidFilename(fname) {
      // eslint-disable-next-line no-useless-escape
      const rg1 = /^[^\\\/\:\*\?\"\'\<\>\|\_\.\+\&\!\#\%]+$/; // forbidden characters \ / : * ? " < > | _ . + & ' ! # %
      const rg2 = /^\./; // cannot start with dot (.)
      const rg3 = /^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i; // forbidden file names
      return rg1.test(fname) && !rg2.test(fname) && !rg3.test(fname);
    },
    itemSelected(val) {
      if (val.length > 0) {
        const item = val[0];

        if (item === undefined) {
          return;
        }

        if (pathInfo.extname(item.path) == ".zip") {
          let filepath = this.deleteInvalidBackslash(item.path);
          filepath = filepath.replace(/^.[/]+/, "");

          this.projectName = pathInfo.basename(filepath, ".zip");
          this.path = pathInfo.dirname(filepath);
          return;
        }

        if (this.loadType) {
          this.projectName = "";
        }

        this.path = item.path;
      } else {
        this.projectName = "";
      }
    },
    openDialog() {
      this.$refs.dialogContainer.openDialog();
    },
  },
};
</script>

<style>
#timeRow {
  height: 95px;
}

#timeField {
  position: relative !important;
  bottom: 17px;
}

#label-duration {
  position: absolute !important;
  top: -19px;
  left: 1px;

  width: 480px;

  font-size: 12px;
  line-height: 15px;
}

#timepicker {
  width: 436px;

  font-family: "Roboto", sans-serif;
  font-size: 16px;
  color: #ffffff;

  border-top: none;
  border-left: none;
  border-right: none;
}

#timepicker:focus {
  outline: none;
}
</style>
